import Vue from "vue";
import Restore from "./Restore.vue";

new Vue({
    render: h => h(Restore)
}).$mount('#app');